import { memo } from 'react';
import EmptyStateLoading from 'FormsUI/components/dashboard/zeroState/freeStarter/EmptyStateLoading';
import NoBusinessUnits from 'FormsUI/components/dashboard/states/NoBusinessUnits';
import ZeroState from 'FormsUI/components/dashboard/ZeroState';
import AsyncReportingAnalyzeTab from 'FormsUI/loadable/AsyncReportingAnalyzeTab';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyzeTab = ({
  isLoadingZeroState,
  isPortalZeroState,
  hasBusinessUnitAccess,
  businessUnits
}) => {
  if (isLoadingZeroState) return /*#__PURE__*/_jsx(EmptyStateLoading, {});
  if (isPortalZeroState) return /*#__PURE__*/_jsx(ZeroState, {});
  if (!businessUnits.length && hasBusinessUnitAccess) return /*#__PURE__*/_jsx(NoBusinessUnits, {});
  return /*#__PURE__*/_jsx(AsyncReportingAnalyzeTab, {});
};
export default /*#__PURE__*/memo(AnalyzeTab);